module.exports = __webpack_public_path__ + "static/media/homepage-assess-info-2.b3aa2321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage-assess-info-2.png
// module id = 782
// module chunks = 0